import React, { Component } from "react";
import { Divider, Dropdown, Header, Nav, Navbar } from "rsuite";
import MenuIcon from '@rsuite/icons/Menu';
import { Icon } from '@rsuite/icons';
import { connect } from "react-redux";
import {
  clickExpand,
  onLogout,
  setDefaultOpenKeys,
  fetchUserBytoken,
} from "../features/main/mainSlice";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import logoa from "../assets/logo.svg";
import "../styles/custom_muis.css";
import "moment/locale/id";
import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
import ArrowUpLineIcon from '@rsuite/icons/ArrowUpLine';
import GlobalIcon from '@rsuite/icons/Global';
import { withTranslation } from 'react-i18next';
import FlagID from "../assets/public/id.svg";
import FlagEN from "../assets/public/gb.svg";

const tokenLogin = process.env.REACT_APP_TOKEN_LOGIN;

class MyHeader extends Component { 
  constructor(props) {
    super(props);
    this.state = { 
      isOpen: false,
    }
  }
  
  componentDidMount() {
    this.fetchProfileAdmin();
  }
  
  fetchProfileAdmin = () => {
    const token = localStorage.getItem(tokenLogin);
    if (token !== "") {
      this.props.fetchDataAdmin();
    } else {
      this.props.logOut();
      // eslint-disable-next-line
      <Redirect to="/login" />;
    }
  };
  
  handleToggle() {
    this.props.onClickExpand();
  }
  
  handleLogout() {
    this.props.logOut();
    // eslint-disable-next-line
    <Redirect to="/login" />;
  }
  
  toggleDropdown = () => {
    this.setState({isOpen: !this.state.isOpen})
  };
  
  
  render() {
    const { profile, i18n, t } = this.props;

    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };

    const currentLanguage = i18n.language;
    
    return (
      <Header>
        <Navbar className="my-navbar1 text-black">
          <Navbar style={{background:"#f1f1f1"}}>
            <Nav>
              <Nav.Item
                icon={<MenuIcon />}
                onClick={()=> this.handleToggle()}
                className="drawwer ml-1 mr-1"
                style={{ fontSize: "20px" }}
              ></Nav.Item>
              <Nav.Item>
                <Link to="/" className="px-1">
                  <img src={logoa} width="145px" />
                </Link>
              </Nav.Item>
              <Nav.Item
              >
                <div className="flex justify-end">
                  <div className="flex flex-col">
                      <div className="font-bold pl-3 pr-3 bg-transparant status-header" style={{height: "50px",width:"max-content"}}>
                        {
                          <h5
                            style={{ fontWeight: 600, width:"max-content" }}
                          >
                            <span style={{color:"#2b2b2b"}}>STATUS</span>
                            <br />
                            <span style={{ color: "#449246" }}>
                              {profile.status_dokumen_name }{" "}
                            </span>
                            {profile.status_dokumen === "Belum Lengkap" && (
                              <a style={{ color: "#269647" }} href="personal">
                                - {t('header.text_complate_here')}!
                              </a>
                            )}
                            {profile.status_dokumen === "Reject" && (
                              <a style={{ color: "#269647" }} href="rej-doc">
                                - {t('header.text_here')}!
                              </a>
                            )}
                          </h5>
                        }
                      </div>
                    </div>

                </div>
              </Nav.Item>
              <Nav.Menu title={currentLanguage === 'id' ? 'Bahasa Indonesia' : 'English'} style={{zIndex: 99}}>
                <Nav.Item onClick={() => changeLanguage('id')} style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                  <img src={FlagID} width={25} />
                  Bahasa Indonesia
                </Nav.Item>
                <Nav.Item onClick={() => changeLanguage('en')} style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                  <img src={FlagEN} width={25} />
                  English
                </Nav.Item>
              </Nav.Menu>
            </Nav>


            {/* <div className="grid grid-cols-2 text-black pt-0">
              <div className="mobile-hide">
                
              </div>

              <div>
                <Nav pullRight className="mobile-hide">
                  <Dropdown
                    className="show dr-logout text-black"
                    style={{ color: "#000" }}
                  >
                    <Dropdown.Item
                      onClick={this.handleLogout.bind(this)}
                      className="dropdown-menuu"
                      icon={<Icon icon="sign-out" />}
                    >
                      Logout
                    </Dropdown.Item>
                  </Dropdown>
                </Nav>

                <Nav className="mobile-view">
                  <Dropdown
                    className="show dr-logout text-black"
                    style={{ color: "#000" }}
                    icon={<Icon icon="user-o" size="lg" />}
                    title={
                      this.props.user.nama_depan
                        ? this.props.user.nama_depan
                        : "Account"
                    }
                  >
                    <Dropdown.Item>
                      {
                        <h5
                          style={{
                            fontWeight: 600,
                            fontSize: 14,
                            marginLeft: 8,
                          }}
                        >
                          STATUS
                          <br />
                          <span style={{ color: "#dc3545" }}>
                            {profile.status_dokumen}{" "}
                          </span>
                          {profile.status_dokumen === "Belum Lengkap" && (
                            <a style={{ color: "#269647" }} href="personal">
                              <br /> Daftar disini
                            </a>
                          )}
                        </h5>
                      }
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={this.handleLogout.bind(this)}
                      className="dropdown-menuu"
                      icon={<Icon icon="sign-out" />}
                    >
                      Logout
                    </Dropdown.Item>
                  </Dropdown>
                </Nav>
              </div>
            </div> */}
          </Navbar>
        </Navbar>
      </Header>
    );
  }
}

const mapDispatchToPros = (dispatch) => {
  return {
    onClickExpand: () => {
      dispatch(clickExpand());
    },
    logOut: () => {
      dispatch(onLogout());
    },
    onLoad: (dt) => {
      dispatch(setDefaultOpenKeys(dt));
    },
    fetchDataAdmin: (payload) => {
      dispatch(fetchUserBytoken(payload));
    },
  };
};
const mapStateToProps = (state) => ({
  user: state.main.currentUser,
  profile: state.main.dtProfileUser,
  errFetchUserByToken: state.main.errFetchUserByToken,
});

const TranslatedMyHeader = withTranslation()(MyHeader);
export default connect(mapStateToProps, mapDispatchToPros)(TranslatedMyHeader);
